import { SearchHospitalService } from '@/services/hospital/SearchHospitalService';
import { UserSigunguDongli } from '@/types/hospital';

import { useGetAddressByLocationQuery } from '../faceToFace.gql.impl';

interface GetAddressByLocation {
  data?: UserSigunguDongli;
  refetch: () => void;
}

const useGetUserAddressByLocation = (
  latitude: number,
  longitude: number,
): GetAddressByLocation => {
  const { data, refetch } = useGetAddressByLocationQuery(
    { longitude, latitude },
    {
      enabled: !latitude || !longitude,
      select: SearchHospitalService.parseHospitalAddressByLocation,
    },
  );
  return { data, refetch };
};

export default useGetUserAddressByLocation;
